/**
 * グラフの軸ラベル・目盛り・凡例に、フォント系設定を一括で反映する。
 */

export type KeisukeUnifiedFontStyle = 'normal' | 'italic' | 'bold';

export type KeisukeUnifiedFontPatch = Partial<{
  fontFamily: string;
  fontWeight: string;
  fontStyle: KeisukeUnifiedFontStyle;
  fontSize: number;
  /** 軸タイトル・目盛り（SVG）に適用。凡例HTMLは tick と同じ色を参照する実装に寄せる */
  color: string;
}>;

/** apply 対象の最小形（Dashboard / ANOVA / TTest の chartSettings と互換） */
export type KeisukeChartSettingsWithUnifiedFont = {
  textStyles: {
    axisLabel: {
      fontFamily: string;
      fontWeight: string;
      fontStyle?: KeisukeUnifiedFontStyle;
      fontSize: number;
      color: string;
    };
    tickLabel: {
      fontFamily: string;
      fontWeight: string;
      fontStyle?: KeisukeUnifiedFontStyle;
      fontSize: number;
      color: string;
    };
  };
  legend: {
    textStyle: {
      fontFamily: string;
      fontWeight: string;
      fontStyle: KeisukeUnifiedFontStyle;
      fontSize: number;
    };
  };
};

export function applyUnifiedKeisukeFont<T extends KeisukeChartSettingsWithUnifiedFont>(
  s: T,
  patch: KeisukeUnifiedFontPatch
): T {
  const axisLabel = { ...s.textStyles.axisLabel };
  const tickLabel = { ...s.textStyles.tickLabel };
  const legendText = { ...s.legend.textStyle };

  if (patch.fontFamily !== undefined) {
    axisLabel.fontFamily = patch.fontFamily;
    tickLabel.fontFamily = patch.fontFamily;
    legendText.fontFamily = patch.fontFamily;
  }
  if (patch.fontWeight !== undefined) {
    axisLabel.fontWeight = patch.fontWeight;
    tickLabel.fontWeight = patch.fontWeight;
    legendText.fontWeight = patch.fontWeight;
  }
  if (patch.fontStyle !== undefined) {
    axisLabel.fontStyle = patch.fontStyle;
    tickLabel.fontStyle = patch.fontStyle;
    legendText.fontStyle = patch.fontStyle;
  }
  if (patch.fontSize !== undefined) {
    axisLabel.fontSize = patch.fontSize;
    tickLabel.fontSize = patch.fontSize;
    legendText.fontSize = patch.fontSize;
  }
  if (patch.color !== undefined) {
    axisLabel.color = patch.color;
    tickLabel.color = patch.color;
  }

  return {
    ...s,
    textStyles: { axisLabel, tickLabel },
    legend: { ...s.legend, textStyle: legendText },
  };
}
